/* eslint-disable @typescript-eslint/no-unused-vars */
import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
// import { toast } from "react-toastify";
import instance from "services/axiosServices";

export interface TorresProps {
  idEmpreendimento: string | undefined | null;
  enabled?: boolean;
}

export function useListarTorres(props: TorresProps & QueryGlobalInterface) {
  const fetchData = async () => {
    const LISTAR_torres = `locais/app-web/torres/v1/${props.idEmpreendimento}`;
    const response = await instance.get(LISTAR_torres);
    const dataWithPagination = {
      data: response?.data?.data,
      pagination: response?.data?.pagination,
    };
    return dataWithPagination;
  };
  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: false,
    retry: false,
    onError: (error: any) => {
      // toast.error(
      //   `Erro ao listar torres. Motivos:\n ${error.response.data.notifications.map(
      //     (item: any) => `${item?.message}`
      //   )} `,
      //   { autoClose: 10000 }
      // );
    },
  });
  return query;
}

export const getListarTorres = async (idEmpreendimento: string) => {
  const url = `locais/app-web/torres/v1/${idEmpreendimento}`;
  const response = await instance.get(url);
  const dataWithPagination = {
    data: response?.data?.data,
    pagination: response?.data?.pagination,
  };
  return dataWithPagination;
};

export const getTorresV1 = async (idEmpreendimento: string): Promise<any> => {
  const url = `locais/app-web/torres/v1/${idEmpreendimento}`;
  const response = await instance.get(url);
  return response?.data;
};
